// extracted by mini-css-extract-plugin
module.exports = {"figura":"Squirtle_figura__E0ktf","ajuste":"Squirtle_ajuste__2m34-","link":"Squirtle_link__1odO0","lista":"Squirtle_lista__1Zcd3"};